"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable react/no-unused-prop-types */

/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var toCurrency_1 = tslib_1.__importDefault(require("../../../utils/toCurrency"));

var styles = tslib_1.__importStar(require("./Marker.style"));

function Marker(_ref) {
  var order = _ref.order,
      price = _ref.price,
      rating = _ref.rating,
      onClick = _ref.onClick,
      selected = _ref.selected;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      currentSelected = _react_1$useState2[0],
      setCurrentSelected = _react_1$useState2[1];

  var handleClick = react_1.useCallback(function () {
    onClick && onClick(Number(order));
  }, [onClick, order]);
  react_1.useEffect(function () {
    if (selected !== undefined) {
      setCurrentSelected(selected);
    }
  }, [selected]);
  return jsx_runtime_1.jsx("span", Object.assign({
    css: [styles.root, currentSelected && styles.floating],
    onClick: handleClick
  }, {
    children: jsx_runtime_1.jsxs("div", Object.assign({
      css: [styles.container, currentSelected && styles.selected]
    }, {
      children: [Boolean(rating) && rating && jsx_runtime_1.jsx("span", Object.assign({
        css: styles.content.rating
      }, {
        children: rating.toFixed(1)
      }), void 0), jsx_runtime_1.jsx("span", Object.assign({
        css: styles.content.price
      }, {
        children: typeof price === 'number' ? "".concat(toCurrency_1.default(price), "\uC6D0") : price
      }), void 0)]
    }), void 0)
  }), void 0);
}

exports.default = react_1.memo(Marker);